import { Perfil } from './Perfil'
export class Usuario extends Perfil{
    public id                : number;
    public nombre            : string;
    public apellido          : string;
    public email             : string;
    public fecha_creacion    : string;
    public perfil            : number;
    public perfil_descripcion: string;
    public estado            : boolean;
    public estado_descripcion: string;
    public cliente           : any;
    public cliente_nombre    : any;
    public puesto    : any;
    public restablecer_password : boolean;
    public sucursal : string;
    public _comite : any[] = [];
    public equipo : any[] = [];

    constructor(usuario : Usuario){
        super(usuario)   

        if(typeof usuario == 'string'){
            let us = usuario
            usuario = JSON.parse(us)
        }
        this.id                   = usuario.id
        this.nombre               = usuario.nombre
        this.apellido             = usuario.apellido
        this.email                = usuario.email
        this.fecha_creacion       = usuario.fecha_creacion
        this.perfil               = usuario.perfil
        this.perfil_descripcion   = usuario.perfil_descripcion
        this.estado               = usuario.estado
        this.estado_descripcion   = usuario.estado_descripcion
        this.cliente              = usuario.cliente
        this.cliente_nombre       = usuario.cliente_nombre
        this.puesto               = usuario.puesto
        this.restablecer_password = usuario.restablecer_password
        this.equipo = usuario.equipo ? usuario.equipo : []; 

    }

    public set comite(value){
        this._comite = value
    }

    public get comite(){
        return this._comite
    }

    get nombreCompleto(){
        return `${this.nombre} ${this.apellido}`;
    }

    get isAdmin(){
        return this.perfil === this.perfilAdmin
    }

    get isCliente(){
        return this.perfil === this.perfilClienteID
    }

    get isOficialDeNegocio(){
        // si es lider de equipo, entonces tambien es oficial de negocio
        return this.perfil === this.perfilOficialDeNegocioID || this.perfil === this.perfilAsistenteComercialID  || this.perfil === this.perfilLiderDeEquipo
    }

    get isOnlyOficialDeNegocio(){
        // solo oficial de negocio, no lider de equipo
        return this.perfil === this.perfilOficialDeNegocioID || this.perfil === this.perfilAsistenteComercialID
    }

    get isAnalistaRiesgo(){
        return this.perfil === this.perfilAnalistaRiesgosID
    }

    get isGerenteComercial(){
        return this.perfil === this.perfilGerenciaComercialID
    }

    get isGerenteGeneral(){
        return this.perfil === this.perfilGerenciaGeneralID
    }

    get isJefeDeAdmision(){
        return this.perfil === this.perfilJefeDeAdmisionID
    }

    get isAsesorLegal(){
        return this.perfil === this.perfilAsesorLegalID
    }

    get isLegal(){
        return this.perfil === this.perfilLegalID
    }

    get isJefeDeOperaciones(){
        return this.perfil === this.perfilJefeDeOperacionesID
    }

    get isSubGerentecomercial(){
        return this.perfil === this.perfilSubGerenciaComercialID
    }

    get isTesoreria(){
        return this.perfil === this.perfilTesoreriaID
    }

    get isLiderDeTesoreria(){
        return this.perfil === this.perfilLiderDeTesoreriaID
    }

    get isRecepcion(){
        return this.perfil === this.perfilRecepcionID
    }

    get isAsistenteCobranzas(){
        return this.perfil === this.perfilAsistenteCobranzasID
    }

    get isAnalistaDeOperaciones(){
        return this.perfil === this.perfilAnalistaOperacionesID
    }

    get isConsultas(){
        return this.perfil === this.perfilConsultaID
    }

    get isLiderDeEquipo(){
        return this.perfil === this.perfilLiderDeEquipo
    }

}

export interface IUsuario{
    id ?                  : number;
    nombre ?              : string;
    apellido ?            : string;
    email ?               : string;
    fecha_creacion ?      : string;
    perfil ?              : number;
    perfil_descripcion ?  : string;
    estado ?              : boolean;
    estado_descripcion ?  : string;
    cliente ?             : number;
    cliente_nombre ?      : string;
    restablecer_password ?: boolean;
    comite ?              : any[];
}
